
import moment from "moment";
import loaderComponent from '@/components/loaderComponent'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Timeline from '@/components/Timeline/Timeline'
import TimelineItem from '@/components/Timeline/Timeline-item'
import ReviewCard2 from '@/components/ReviewSection/ReviewCard2'
import ActivityBlog from '@/components/ActivityBlog/ActivityBlog'
import RentalSection from "@/components/RentalSection.vue";
import googleAd from '@/components/gAdUnitCode'
import Toc from '@/components/Toc'
import ActivityCard from "@/components/ActivityCard.vue";

export default {
  scrollToTop: true,
  components: {
    VueSlickCarousel,
    loaderComponent,
    Timeline,
    TimelineItem,
    ReviewCard2,
    ActivityBlog,
    RentalSection,
    googleAd,
    Toc,
    ActivityCard
  },
  head() {
    return {
      title: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDesc()
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: this.metaKeywords()
      },
      {
        hid: 'image',
        property: 'image',
        content: this.metaImage()
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.metaImage()
      },
      {
        hid: 'og:image:secure_url',
        property: 'og:image:secure_url',
        content: this.metaImage()
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: this.metaDesc()
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: this.seoData && this.seoData.title ? this.seoData.title : 'Goa App',
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: this.metaDesc()
      }
      ],
    }
  },
  data() {
    return {
      gallerySmall: {
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },

          {
            breakpoint: 490,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          },]
      },
      galleryBig: {
        infinite: true,
        autoplay: false,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      datePicker: null,
      token: null,
      form: {
        pickUpDate: null,
        pickUpTime: null,
        dropDate: null,
        dropTime: {
          hh: "09",
          mm: "00",
          a: 'am'
        },
        vehicleQuantity: 1,
      },
      blogId: null,
      blogData: null,
      relatedListings: null,
      relatedBlogs: null,
      loading: true,
      seoData: null
    };
  },
  jsonld() {
    if (!this.blogData) {
      return null
    }
    return {
      '@context': 'https://schema.org',

      "@graph":
        [
          // {
          //   '@type': 'NewsArticle',
          //   mainEntityOfPage: {
          //     '@type': 'WebPage',
          //     '@id': `https://www.goa.app/blog/${this.blogId}`
          //   },
          //   headline: this.blogData && this.blogData.post && this.blogData.post.title ? this.blogData.post.title + " | Goa App" : 'Goa App',
          //   description: this.metaDesc(),
          //   image: this.metaImage(),
          //   author: {
          //     '@type': 'Person',
          //     name: 'GoaApp',
          //     url: "https://goa.app"
          //   },
          //   datePublished: this.blogData && this.blogData.post && this.blogData.post.createdAt ? this.blogData.post.createdAt : 'Goa App',
          //   dateModified: this.blogData && this.blogData.post && this.blogData.post.createdAt ? this.blogData.post.createdAt : 'Goa App',
          //   publisher: {
          //     '@type': 'Organization',
          //     name: 'GoaApp',
          //     logo: {
          //       '@type': 'ImageObject',
          //       url: 'https://goa.app/goa-app-logo.svg'
          //     }
          //   }
          // },
          {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/blog/${this.blogId}`,
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `https://www.goa.app/blog/${this.blogId}`
            },
            headline: this.blogData && this.blogData.post && this.blogData.post.title ? this.blogData.post.title + " - Goa App" : 'Goa App',
            "name": this.blogData && this.blogData.post && this.blogData.post.title ? this.blogData.post.title : 'Goa App',
            description: this.metaDesc(),
            datePublished: this.blogData && this.blogData.post && this.blogData.post.createdAt ? this.blogData.post.createdAt : 'Goa App',
            dateModified: this.blogData && this.blogData.post && this.blogData.post.createdAt ? this.blogData.post.createdAt : 'Goa App',
            author: {
              '@type': 'Person',
              name: 'Goa App',
              url: "https://goa.app"
            },
            publisher: {
              '@type': 'Organization',
              "@id": "https://goa.app",
              name: 'Goa App',
              logo: {
                '@type': 'ImageObject',
                url: 'https://goa.app/goa-app-logo.svg'
              }
            },
            "image": {
              "@type": "ImageObject",
              "@id": this.metaImage(),
              "url": this.metaImage(),
              "height": "362",
              "width": "388"
            },
            "url": `https://www.goa.app/blog/${this.blogId}`,
            "isPartOf": {
              "@type": "Blog",
              "@id": "https://www.goa.app/blog/",
              "name": "Goa App Blog",
              "publisher": {
                "@type": "Organization",
                "@id": "https://goa.app",
                "name": "Goa App"
              }
            },

          }
        ]
    };
  },
  async validate({
    params,
    store
  }) {
    // await operations
    if (params.slug != (null || "")) {
      this.blogId = params.slug;
      return true // if the params are valid
    } else {
      return false // will stop Nuxt.js to render the route and display the error page
    }
  },
  created() {
    this.blogId = this.$route.params.slug;
  },
  async fetch() {
    this.seoData = await fetch(this.$config.fetchUrl + '/api/posts/seo/getSEOContent/' + this.blogId)
      .then(res => res.json()).catch(error => {
        //this.$router.push({
//          path: '/'
//        })
        console.error("There was an error!", error); return false;
      });
  },
  mounted() {
    this.getAllData()
  },
  methods: {
    async getAllData() {
      // Get post data
      this.blogData = await fetch(this.$config.fetchUrl + '/api/posts/app/getPostBySlug/' + this.blogId).then(res =>
        res.text()).catch(error => {
          console.error("There was an error!", error); return false;
          this.$router.push({
            path: '/blog'
          })
        });
      this.blogData = this.getCryptKey(this.blogData);
      this.loading = false
      this.relatedListings = await fetch(this.$config.fetchUrl + '/api/posts/app/getFeaturedActivities').then(
        res => res.text());
      this.relatedListings = this.getCryptKey(this.relatedListings);
      this.relatedBlogs = await fetch(this.$config.fetchUrl + '/api/posts/app/getFeaturedBlogs').then(res => res
        .text());
      this.relatedBlogs = this.getCryptKey(this.relatedBlogs);
    },
    disabledBeforePickUp(date) {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + 1);
      if (this.form.pickUpDate)
        return date <= this.form.pickUpDate;
      return date <= currentDate
    },

    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description
      } else {
        return 'Find out the top things to do in Goa. Book must do activities like Parasailing, Kayaking, Dudhsagar Waterfalls Tour, Scuba Diving, Grand Island and Butterfly Island Tours at the lowest prices. Secure bookings and instant confirmations only on Goa App.'
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return 'Goa Tourism, Travel Guide, Must do Activities, Top Activities to do in Goa, Goa, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Kayaking, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Offers, Travel Goa'
      }
    },

    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      } else {
        return 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D'
      }
    },

    syncSliders(currentPosition, nextPosition) {
      this.$refs['slick1'].goTo(nextPosition)
      this.$refs['slick2'].goTo(nextPosition)
    },
    getListingImage(blogImage) {
      if (blogImage.length > 0) {
        return blogImage[0]
      } else {
        return ""
      }
    },
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/square.svg`)
    },
    // To format the date using moment js
    getDate(blogDateSent) {
      return moment(blogDateSent).format('ll')
    },
    getBlogDesc(blogDescSent) {
      return blogDescSent.split('. ', 1)[0];
    },
    getGuidelineArr(guideline) {
      let arr = guideline.split("\n")
      arr = arr.filter(item => item && item != '\r');
      return arr
    },
    
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
      return str;
    },

    goTotags(tag) {
      let tagSlug = this.string_to_slug(tag)
      this.$router.push({
        path: "/tags/" + tagSlug
      });
    },
  }
};

